import type { FeatureGroup } from '../../types';

export const MARKETING_FEATURE_GROUP: FeatureGroup = {
  guid: 'e1a5b8d3-4c67-4e82-9d41-8a2b3f5c0000',
  name: 'marketing',
  description: 'Root group for all marketing features — the marketing workspace',
  product: 'marketing',
};
